<template>
    <div class="content-course-box__add-materials">
        <VideoUpload
            @uploadFileData="coverUpload"
            :video-data="{ video: config.video, poster: config.preview, track: config.preview }"
            :show-key="showKey"
            :controls="controls"
            @deleteFile="onDeleteMethod"
        ></VideoUpload>
        <div class="content-course-box__add-materials__save">
            <div class="content-course-box__add-materials__save-items">
                <button type="button" class="btn btn_revert" @click="reset">Отменить</button>
            </div>
            <div class="content-course-box__add-materials__save-items">
                <button type="button" class="btn" @click="onSaveVideo">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import VideoUpload from "../../../course-module/course-creating/components/VideoUpload";
import { uploadFile } from "../../../course-module/course-creating/services/course-creating-service";
export default {
    name: "MaterialVideo",
    props: ["config"],
    components: { VideoUpload },

    data: () => ({
        show: false,
        showKey: 0,
        controls: [
            {
                id: 1,
                label: "Видео",
                name: "",
                preview: "Добавить видео",
                size: "",
                isActive: false,
                directiveId: "video",
                url: ""
            },
            {
                id: 2,
                label: "Обложка",
                name: "",
                preview: "Добавить обложку видео",
                size: " ",
                isActive: false,
                directiveId: "poster",
                url: ""
            },
            {
                id: 3,
                label: "Субтитры",
                name: "",
                preview: "Добавить субтитры",
                size: " ",
                isActive: false,
                directiveId: "track"
            }
        ]
    }),

    methods: {
        coverUpload(file) {
            uploadFile({ file: file.file })
                .then(res => {
                    const data = res.data.data;

                    this.controls = this.controls.map(item => {
                        if (item.directiveId === file.id) {
                            item.isActive = true;
                            item.name = file.file.name;
                            item.url = data.url;
                            item.videoId = data.id;
                            item.size = Math.ceil(file.file.size / (1024 * 1024)).toFixed(2);
                        }
                        return item;
                    });
                    this.showKey++;
                })
                .catch(err => {
                    alert(err.statusText);
                });
        },
        onDeleteMethod(id) {
            this.formData[id] = {
                src: null,
                name: null
            };

            const controlItem = this.controls.find(item => item.directiveId === id);

            controlItem.size = "";
            controlItem.name = "";
            controlItem.isActive = false;
        },
        onSaveVideo() {
            this.config.video = {
                src: this.controls[0].url,
                name: this.controls[0].name,
                id: this.controls[0].videoId
            };

            this.config.preview = {
                src: this.controls[1].url,
                name: this.controls[1].name,
                id: this.controls[1].videoId
            };
            this.$emit("emitData", { name: "navigation", to: "v-add-materials" });
        },
        reset() {}
    }
};
</script>

<style scoped></style>
